import { navEvents } from '../lib/nav-events';

export let NavigationMixins = {
    data: {
        navigation: {
            showSearch: false,
            searchValue: ""
        }
    },
    methods: {
        navigationToggleSearch: function () {
            this.navigation.showSearch = !this.navigation.showSearch;
            if (this.navigation.showSearch) {
                this.$nextTick(function () {
                    this.$refs.searchLogo.focus();
                });
            }
        },
        setBreadcrumbSize: function () {
            let breadcrumb = this.$refs.breadcrumb;
            if (breadcrumb) {

                let children = Array.from(breadcrumb.children);
                let bR = breadcrumb.getBoundingClientRect();
                let x = 0;
                children.forEach(function (it) {
                    let cR = it.getBoundingClientRect()
                    x += cR.width;
                });
                let i = breadcrumb.lastChild.getBoundingClientRect().width;
                breadcrumb.lastChild.style.maxWidth = (i + (bR.width - x)) + "px";
            }
        }
    },
    mounted: function () {
        let vm = this;
        vm.setBreadcrumbSize()
        window.addEventListener('resize', vm.setBreadcrumbSize);

        navEvents();
    },
}